<div class="modal-overlay" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="closeModal()">✖</button>
    <ng-content></ng-content>
  </div>
</div>
